import { Box, Container, Typography } from "@material-ui/core"
import PropTypes from "prop-types"
import React from "react"

import OpenSourceContainer from "./OpenSourceContainer"

import backgroundImage from "../../../content/assets/open-source-bg.jpg"
import { withStyles } from "@material-ui/core/styles"

const styles = (theme) => ({
  container: {
    marginBottom: theme.spacing(28),
    marginTop: theme.spacing(16),
  },
  headerContainer: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top right",
    borderRadius: 8,
    display: "flex",
    height: 150,
    justifyContent: "center",
    width: "100%",
  },
  header: {
    color: "#fff",
  },
  root: {
    // backgroundColor: "rgba(0, 0, 0, 0.01)",
    display: "flex",
    marginTop: -theme.spacing(12),
    overflow: "hidden",
  },
})

function OpenSourcePage(props) {
  const { classes } = props

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Box className={classes.headerContainer}>
          <Typography
            className={classes.header}
            variant="h3"
            align="center"
            component="h1"
          >
            Open Source
          </Typography>
        </Box>

        <OpenSourceContainer />
      </Container>
    </section>
  )
}

OpenSourcePage.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(OpenSourcePage)
